<div class="header">
    <h2>{{ 'modules.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="modules-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'modules.error.unavailable' | translate" />
} @else if (module(); as module) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'modules.fieldset.basic' | translate }}</h2>
            <app-form-input [control]="form.controls.name" [label]="'modules.form.name' | translate" inputId="name" testId="modules-edit-name" />

            <app-form-textarea
                [control]="form.controls.description"
                [label]="'modules.form.description' | translate"
                inputId="description"
                testId="modules-edit-description"
            />
        </div>

        <app-module-item-list
            [items]="selectedItems()"
            testId="modules-edit-items"
            (add)="openItemDialog()"
            (remove)="removeItem($event)"
            (reorder)="reorderItems($event)"
        />
    </form>

    <div class="footer">
        <p-button [label]="'modules.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="modules-edit-cancel" (onClick)="close()" />
        <p-button
            type="submit"
            [label]="'modules.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="modules-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
